import { Component, ChangeDetectionStrategy} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss']
})
export class CustomDropdownComponent implements ICellRendererAngularComp {

  params: any;
  label: string;
  masterData: any;
  placeHolder: string;
  filteredData: any;
  ddControl = new FormControl();
  selectedValues: any = new Array<string>();
  filteredValues: Observable<string[]>;
  lastFilter: string = '';
  isEdited: boolean = true;
  disablePointerEvent: boolean = false;

  agInit(params): void {
    this.masterData = params?.masterData;
    if (params.selectedValues && params.selectedValues.length > 0) {
      this.selectedValues.push(params.selectedValues);
      this.ddControl.setValue(this.selectedValues);
    }
    else {
      this.ddControl.setValue("");
    }

    //Below line is for LTC Nutrition change component
    if (params?.sourcePage === 'LTCNutritionChange') {
      this.disablePointerEvent = params?.data?.ltcNutritionStatusChangeId !== 0;
    }

    this.placeHolder = params.placeHolder;
    this.params = params;
    this.label = this.params.label || null;
    this.filteredValues = this.ddControl.valueChanges.pipe(
      startWith<string | string[]>(''),
      map((value) => this.updateSelectList(value)),
      map((value) => (typeof value === 'string' ? value : this.lastFilter)),
      map((filter) => this.filter(filter))
    );
  }

  refresh(): boolean {
    if (this.isEdited) {
      return false;
    }
    return true;
  }
  updateSelectList(value: any): any {
    let valueToGrid;
    if (!Array.isArray(value)) {
      this.isEdited = false;
      this.selectedValues = [];
      if (value && value.includes(';')) {
        value
          .toString()
          .split(';')
          .forEach((item, index) => {
            if (
              this.masterData.includes(item.trim()) &&
              !this.selectedValues.includes(item.trim())
            ) {
              this.selectedValues.push(item.trim());
            }
          });
      } else if (value && this.masterData.includes(value.trim()) && !this.selectedValues.includes(value.trim())) {
        this.selectedValues.push(value.trim());
      }
      valueToGrid = value;
    }
    if (Array.isArray(value)) {
      value.forEach((ddValue, index) => {
        if (index === 0) {
          if (ddValue && ddValue.includes(';')) {
            ddValue
              .toString()
              .split(';')
              .forEach((item, index) => {
                if (item && this.masterData.includes(item.trim())) {
                  this.addToSelectedIfMissing(item.trim());
                }
              });
          }
          valueToGrid = ddValue;
        } else {
          valueToGrid += '; ' + ddValue;
        }
      });
    }
    if (this.params && valueToGrid && !valueToGrid.includes('(Data Error)')) {
      this.params.data[this.params.column.colId] = valueToGrid;
      this.params.masterData = this.masterData;
      this.params.value = valueToGrid;
      this.params.context.componentParent.customRefresh(this.params.column.colId);
    }
    if (this.params && this.ddControl.touched && (valueToGrid === '' || valueToGrid === undefined)) {
      this.params.data[this.params.column.colId] = '';
      this.params.masterData = this.masterData;
      this.params.value = '';
      this.params.context.componentParent.customRefresh(this.params.column.colId);
    }
    this.isEdited = true;
    return value;
  }
  filter(filter: string): string[] {
    this.lastFilter = filter;
    if (filter) {
      if (this.lastFilter.includes(';')) {
        filter = filter.split(/[; ]+/).pop().trim();
      }
      return this.masterData.filter((option) => {
        return option.toLowerCase().includes(filter.toLowerCase());
      });
    }
    else {
      return this.masterData.slice();
    }
  }
  displayFn = (value: string[] | string) => {
    let displayValue: string;
    if (Array.isArray(value)) {
      value.forEach((ddValue, index) => {
        if (index === 0) {
          displayValue = this.processFirstDisplayValue(ddValue);
        } else {
          displayValue += '; ' + ddValue;
        }
      });
    }
    return displayValue;
  }

  private processFirstDisplayValue(ddValue: string): string {
    if (!ddValue || !ddValue.includes(';')) {
      if (ddValue && this.masterData.includes(ddValue.trim())) {
        this.addToSelectedIfMissing(ddValue.trim());
      }
      return ddValue;
    }
    const items = ddValue.toString().split(';');
    items.forEach(item => {
      if (item && this.masterData.includes(item.trim())) {
        this.addToSelectedIfMissing(item.trim());
      }
    });
    return items.map(item => item.trim()).join('; ');
  }

  private addToSelectedIfMissing(val: string) {
    if (this.selectedValues && !this.selectedValues.includes(val)) {
      this.selectedValues.push(val);
    }
  }

  optionClicked(event: Event, ddValue: string) {
    event.stopPropagation();
    this.toggleSelection(ddValue);
  }

  toggleSelection(ddValue: string) {
    const i = this.selectedValues.indexOf(ddValue);
    if (i > -1) {
      this.selectedValues.splice(i, 1);
    } else {
      this.selectedValues.push(ddValue);
    }
    this.isEdited = false;
    this.ddControl.setValue(this.selectedValues);
    this.ddControl.markAllAsTouched();

    if(this.params.column.colId === 'rdInterventions'){
      this.setFocus(this.params.node, 'rdInterventions');
    }

     if(this.params.column.colId === 'nutritionIntervention'){
      this.setFocus(this.params.node, 'nutritionIntervention');
    }
    
  }

  toggleSelectionOnKeyPress(ddValue: string) {
    const i = this.selectedValues.indexOf(ddValue);
    if (i > -1) {
      this.selectedValues.splice(i, 1);
    } else {
      this.selectedValues.push(ddValue);
    }
    this.isEdited = false;
    this.ddControl.setValue(this.selectedValues);
    this.ddControl.markAllAsTouched();
  }

  clearText() {
    this.ddControl.markAllAsTouched();
    this.ddControl.setValue('');
    this.selectedValues = [];
  }

  onkeyPress(e){
    if(e.keyCode === 13){
      let valueFiltered = e.currentTarget.value;
      let splitValue = valueFiltered.split(";");
      if(splitValue.length >1){
        splitValue.forEach((option, index) => {
          if (option && this.masterData.includes(option.trim())) {
            this.addToSelectedIfMissing(option.trim());
          } else if(option.trim()){
            const value = this.masterData.find(x => x.toLowerCase().includes(option.trim().toLowerCase()));
            this.toggleSelectionOnKeyPress(value);
          } else{
            e.preventDefault();
          }
        });
      } else if(valueFiltered){
        const value = this.masterData.find(x => x.toLowerCase().includes(valueFiltered.toLowerCase()));
        this.toggleSelectionOnKeyPress(value);
      } else{
        e.preventDefault();
      }
      
    }else{
      e.preventDefault();
    }
  }

  openPanel(event, trigger: MatAutocompleteTrigger){
    event.stopPropagation();
    trigger.openPanel();
  }

  setFocus(rowNode, columnName) {
    this.params.api.setFocusedCell(rowNode.rowIndex, columnName);
    this.params.api.startEditingCell({
      rowIndex: rowNode.rowIndex,
      colKey: columnName,
    });
  }

}